import { Route, Routes } from "react-router-dom";
import CertificateFormPage from "./CertificateFormPage";
import CertificateLoader from "./CertificateLoader";
import CertificatesPage from "./CertificatesPage";
import CPSCProductsPage from "./CPSCProductsPage";

const ComplianceRoutes = () => {
  return (
    <Routes>
      <Route index element={<CertificatesPage />} />
      <Route path="new" element={<CertificateFormPage mode="create" />} />
      <Route path="cpsc" element={<CPSCProductsPage />} />
      <Route path=":id" element={<CertificateLoader />} />
    </Routes>
  );
};

export default ComplianceRoutes;
